//=============================================================================
// Contents   : HRDB
//              完了テンプレート
//              CmnConfirm
// Author     : RV小寺
// LastUpdate : 2022/12/9
// Since      : 2022/12/9
//=============================================================================

/* ======================================================================================================================================================= */  
/* ==================================================================== Start Of Program ================================================================= */  
/* ======================================================================================================================================================= */ 


/* ======================================================================== */  
/* ============================ import ==================================== */  
/* ======================================================================== */  

/* ====== React ====== */
import React from "react";
import { useLocation, useNavigate } from 'react-router-dom';

/* ====== CSS ====== */
import styled from "styled-components";
/* ====== Image ====== */

/* ====== Component Js/Jsx ====== */
import { assets } from '03CommonApiParts/Configuration';

/* ====== Style ====== */
import { Title } from "01Pages/Common/UiParts/Title";
import { ButtonBlueOutline } from "02CommonUiParts/ButtonParts/ButtonBase";

/* ======================================================================== */  
/* ============================ Styles ==================================== */  
/* ======================================================================== */ 

/* ====== Styled Components ====== */
const SdivPagetWrapper = styled.div`//ページ枠
	height: calc(100vh - 100px);
	display: flex;
	justify-content: center;
`;
const SdivContentWrapper = styled.div`//コンテンツ枠
	width: 500px;
	height: 200px;
	text-align: center;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
`;
const SdivMessage = styled.div`//ボタン枠
    white-space: pre-wrap;
    word-wrap: break-word;
    color : #000;
    font-weight:bold;
`;
const SdivButtonGroup = styled.div`//ボタン枠
	display: flex;
	width: 100%;
	justify-content: center;
	margin: 0 auto;
`;
// const SbuttonList = styled.button`//一覧へボタン
// 	justify-content: center;
//     background-color: ${assets().color.white};
//     border: solid 1px #2e94b9;
//     border-radius: 3px;
//     color: ${assets().color.blue};
//     display: flex;
//     font-weight:bold;
//     position: relative;
//     padding:0px;
//     align-items: center;
//     pointer-events: ${(props) => props.pointerEvents};
//     white-space:nowrap;
// 	width: 100px;
// 	height: 30px;
//     &:hover{
//         background-color: ${assets().color.whiteHover};
//         cursor: pointer;
//     }
//     &:hover label{
//         display: block;
//     }
//     &:active{
//         top:1px;
//         left:1px;
//         box-shadow: none;
//         background-color:${assets().color.blue};
//         color:${assets().color.white};
//     }
//     &:disabled{
//         color:${assets().color.disabled};
//         background-color:${assets().color.white};
//         border:1px solid #BDBDBD;
//     }
// `;

/* ======================================================================== */  
/* ================== global variables/functions ========================== */  
/* ======================================================================== */  
/* ベース64スイッチ */

/* ======================================================================== */  
/* ================================ dummy ================================= */  
/* ======================================================================== */

/* ======================================================================== */  
/* ============================ Main ====================================== */  
/* ======================================================================== */ 

/* ========= 完了テンプレート ========= */
export const CmnConfirm = () => {

    /* ---------------------------------------------------- */
    /* ------------------ Instance ------------------------ */
    /* ---------------------------------------------------- */

    const navigate = useNavigate();//画面遷移用
    const location = useLocation();//画面遷移用

    /* ----------------------------------------------------- */
    /* ----------------- reack-hook-form ------------------- */
    /* ----------------------------------------------------- */

    /* ====== hookformを定義 ====== */ 
    // const { register, handleSubmit, getValues, setValue, reset, formState: { errors } } = useForm({//setValue, onChange
	// 	mode: 'onBlur',
	// 	reValidateMode: 'onChange',
	// 	shouldUseNativeValidation: false,
	// 	shouldUnregister: false,
	// 	defaultValues: {
	// 		// payload: [{example:''}]
	// 	},
    //     escalationCode:'false'
	// });

    /* ====== useWatchを定義 ====== */ 

    /* ---------------------------------------------------- */
    /* ------------------ variables ----------------------- */
    /* ---------------------------------------------------- */
    const message = location?.state.message;
    const title = location?.state.title;
    const buttonList = location?.state.button;//{type: ボタン種類, name: ボタン名, path: 遷移先}
    /* ====== sessionStorageからの情報を定義 ====== */ 

    /* ====== localStorageからの情報を定義 ====== */ 

    /* ====== storageから取得した情報をJavaScriptオブジェクトに変換 ====== */ 


 
    /* ---------------------------------------------------- */
    /* ---------------------- state ----------------------- */
    /* ---------------------------------------------------- */

    /* ---------------------------------------------------- */
    /* ---------------------- function -------------------- */
    /* ---------------------------------------------------- */

    /* ---------------------------------------------------- */
    /* ----------------------- data ----------------------- */
    /* ---------------------------------------------------- */
    
    /* ---------------------------------------------------- */
    /* ----------------------- jsx ------------------------ */
    /* ---------------------------------------------------- */

    /* ---------------------------------------------------- */
    /* -------------------- Start Render ------------------ */
    /* ---------------------------------------------------- */ 

    return(
        <>
			<Title text = {title}/>
                <>
					<SdivPagetWrapper>
						<SdivContentWrapper>
							<SdivMessage className='headText' style={{fontSize:assets().size.titleText}}>{message}</SdivMessage>
							<SdivButtonGroup>
								{/* ボタンを一つにしたいとき：<div>ごとボタンを消す */}
								{/* ボタンを増やしたいとき：<div>ごと下に増やす */}
                                {buttonList?.map((item,index) => (
                                    <div key={`${item.name}${index}`}style={{margin:'30px 20px'}}>
                                        {/* 画面名でボタンの大きさが各画面でButtonにwidthを渡すようにする */}
                                        <ButtonBlueOutline
                                            text={item.name}
                                            onClick={() => navigate(item.path, {state:item.state, replace:true})}
                                        />
                                    </div>
                                ))}
							</SdivButtonGroup>
						</SdivContentWrapper>
					</SdivPagetWrapper>
            	</>
        </>
    )
};

/* ======================================================================================================================================================= */  
/* ==================================================================== End Of Program =================================================================== */  
/* ======================================================================================================================================================= */

